import eventMixin from './mixins/event';
import Logger from './logger';

export default class Cart {

	constructor() {
		this.NAME = `Cart`;
		this.cartJson = null;
	}

	init() {
		Logger.info(`${this.NAME} > init`);
	}

	/**
	 * add - Add items to the cart
	 *
	 * @param {*} items
	 */
	async add(items) {
		Logger.info(`${this.NAME} > add`);

		const self = this;

		// Set up the payload
		let formData = {
			'items': []
		};
		items.forEach((item) => {

			if (!item.id) {
				Logger.error(`${this.NAME} > add > No product id provided. Omitting product from cart add.`)
				return;
			}

			if (!item.quantity) {
				item.quantity = 1;
			}

			formData.items.push({
				'id': item.id,
				'quantity': item.quantity
			});
		});

		self.trigger(`cart.adding`, formData);
		self.triggerUpdating();

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
			.then(response => {
				return response.json();
			})
			.then(json => {
				self.trigger(`cart.added`, formData);
				self.triggerUpdated();
				self.get();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	/**
	 * change - This function will change an existing line item in the cart.
	 *
	 * This is a good function to use if you have the key of the line item (not the variant ID).
	 *
	 * @param {*} lineItemKey
	 * @param {*} updates
	 * @param {*} attributes
	 */
	async change(lineItemKey, updates, attributes) {
		Logger.info(`${this.NAME} > change`);

		const self = this;

		// Set up the payload
		let formData = {
			id: lineItemKey
		};

		if (updates.quantity != null) {
			formData.quantity = updates.quantity
		}

		if (attributes != null) {
			formData.attributes = attributes;
		}

		self.trigger(`cart.changing`, formData);
		self.triggerUpdating();

		const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		});

		const json = await response.json();

		self.trigger(`cart.changed`, formData);
		self.triggerUpdated();
	}

	async get(preferCached) {
		Logger.info(`${this.NAME} > get`);

		const self = this;

		self.trigger(`cart.getting`);

		// if (preferCached && self.cartJson) {
		// 	return self.cartJson;
		// }

		await fetch(window.Shopify.routes.root + 'cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(response => {
				return response.json();
			})
			.then(json => {
				self.cartJson = json;
				self.trigger(`cart.get`, json);
			})
			.catch((error) => {
				console.error('Error:', error);
			});

		const cartMetafields = await this.getCartMetafields();

		for (const item in self.cartJson.items) {
			for (const metafield in cartMetafields.items) {
				if (cartMetafields.items[metafield].variant_id == self.cartJson.items[item].variant_id) {
					self.cartJson.items[item].metafields = cartMetafields.items[metafield];
				}
			}
		}

		return self.cartJson;
	}

	/**
	 * getCartMetafields - Get the cart metafields
	 *
	 * @returns json
	 */
	async getCartMetafields() {
		Logger.info(`${this.NAME} > getCartMetafields`);

		// This template is found in /templates/cart.metafields.json.liquid
		const url = `/cart?view=metafields.json`;

		// Get the cart metafields from url
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		});

		const json = await response.json();

		return json;
	}

	triggerUpdating() {
		this.trigger(`cart.updating`);
	}

	triggerUpdated() {
		this.trigger(`cart.updated`);
	}

	/**
	 * update - Update a variant in the cart
	 *
	 * Ref:
	 * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-update-js
	 *
	 * @param {*} variantId
	 * @param {*} updates
	 * @param {*} attributes
	 */
	async update(variantId, updates, attributes) {
		Logger.info(`${this.NAME} > change`);

		const self = this;

		// Set up the payload
		let formData = {};

		// Updates should resemble:
		// { variantId: quantity, variantId: quantity}
		if (updates != null) {
			formData.updates = updates;
		}

		if (attributes != null) {
			formData.attributes = attributes;
		}

		self.trigger(`cart.changing`, formData);
		self.triggerUpdating();

		const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		});

		const json = await response.json();

		self.trigger(`cart.changed`, formData);
		self.triggerUpdated();
	}
}

// Mixins
Object.assign(Cart.prototype, eventMixin);
